import type {
  TrackSearchEventParams,
  TrackSearchSuggestionEventParams,
  TrackingEvent,
  TrackingPayload,
} from '~/types/tracking'

const useSearchEvents = (
  track: (event: TrackingEvent, payload: TrackingPayload) => any,
) => ({
  trackSearch: ({
    searchTerm,
    suggestion = '',
    searchAction,
    searchDestination = '',
  }: TrackSearchEventParams) => {
    track('search', {
      search_term: searchTerm,
      search_term_completed: suggestion || '',
      search_action: searchAction,
      search_destination: searchDestination,
    })
  },
  trackSearchSuggestions: ({
    searchTerm,
    suggestion,
    position,
    section,
  }: TrackSearchSuggestionEventParams) => {
    track('search_suggestions_click', {
      search_term: searchTerm,
      search_suggestion: suggestion,
      search_suggestion_position: position,
      search_suggestion_section: section,
    })
  },
})

export default useSearchEvents
